var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconLightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8499 4.89738C42.8858 -1.12347 33.3937 -1.65805 26.8035 3.65576C19.9324 -1.80769 10.0383 -0.933688 4.2111 5.65146C-1.61609 12.2366 -1.36696 22.2621 4.77997 28.5439L25.4545 49.4199C25.8182 49.7911 26.3139 50 26.831 50C27.3481 50 27.8438 49.7911 28.2075 49.4199L44.5416 32.8942L28.6755 16.8828L26.6475 18.9305L40.481 32.8942L26.8035 46.7096L6.78962 26.4961C1.66765 21.3743 1.35616 13.1195 6.07729 7.619C10.7984 2.11846 18.9348 1.25653 24.6837 5.64792L11.1806 19.3012C11.4588 19.9 11.8358 20.4468 12.2955 20.9181L12.9562 21.5852L27.8083 6.60694C33.0013 1.75175 41.003 1.69305 46.2653 6.47153C51.5276 11.25 52.3159 19.2906 48.0837 25.0182L34.5897 11.3835C33.9967 11.6646 33.4553 12.0453 32.9884 12.5093L32.3277 13.1764L48.2167 29.2249L49.2307 28.1316C55.3394 21.5471 55.1709 11.2558 48.8499 4.87885V4.89738Z",
    fill: "url(#paint0_linear_111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.961 10.1095C39.5494 6.64216 34.0269 6.64216 30.6153 10.1095L16.144 24.8488L11.9799 20.6249C9.93667 18.5644 9.66104 15.2985 11.329 12.9129C12.997 10.5273 16.1165 9.72551 18.6956 11.0197L20.7982 8.88671C17.0409 6.34636 12.0013 7.15054 9.1862 10.7397C6.37108 14.3288 6.71272 19.5142 9.97341 22.6878L25.4525 38.4586C25.7201 38.7339 26.0846 38.8888 26.4649 38.8888C26.8452 38.8888 27.2097 38.7339 27.4773 38.4586L36.6392 29.124L34.6053 27.0891L26.4649 35.3642L18.1688 26.9117L32.6401 12.1538C34.6625 10.0721 37.8679 9.79127 40.2095 11.4907C42.551 13.1901 43.3379 16.3684 42.0677 18.996L44.1704 21.143C46.3386 17.627 45.837 13.0515 42.961 10.1095Z",
    fill: "url(#paint1_linear_111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111",
    x1: -0.0927288,
    y1: 24.9997,
    x2: 53.7043,
    y2: 24.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E4156A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111",
    x1: 7.41723,
    y1: 23.1966,
    x2: 45.508,
    y2: 23.1966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#143961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#005E9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconLightBg);
export default __webpack_public_path__ + "static/media/LogoIconLightBg.2253262215c0551e62565614b5d7384e.svg";
export { ForwardRef as ReactComponent };